import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { posts } from '../../../data/blog-posts';
import { brands } from '../../../data/shop-brands';
import { products } from '../../../data/shop-products';
import { categories } from '../../../data/shop-block-categories';
import { ApiService } from '@app/shared/services/api.service';
import { Observable, timer, Subscription } from 'rxjs';
import { Product } from '@app/shared/interfaces/product';
import { ProductCardComponent } from '@app/shared/components/product-card/product-card.component';
import { QuickviewService } from '@app/shared/services/quickview.service';
import { ActivatedRoute, Router } from '@angular/router';
import { sportCategory, SportCategory } from '@app/shared/interfaces/SportCategory';
import { JsonResult } from '@app/shared/interfaces/JsonResult';
import { CategoryService } from '@app/shared/services/category.service';
import { StoreService } from '@app/shared/services/store.service';
import { PostService } from '@app/shared/services/post.service';
import { Post } from '@app/shared/interfaces/post';
import { IBanner, LocalStoreService } from '@app/shared/services/localStore.service';





@Component({
    selector: 'app-home-bakeryshop',
    templateUrl: './page-bakeryshop.component.html',
    styleUrls: ['./page-bakeryshop.component.scss']
})
export class PageBakeryShopComponent implements OnInit, OnDestroy {


    tags = ['featured', 'bestseller', 'newArrival', 'topRated', 'specialOffer'];

    // @HostListner('window-scroll', ['$event'])
    // doScoll(event){

    // }

    // base all products
    products = [];
    // filtered products by more sale, top, featured, NewArrivals
    Bestsellers = [];
    Featured = [];
    NewArrivals = [];
    TopRated = [];
    SpecialOffers = [];

    categories = [];
    posts = [];
    brands = []; // brands;
    links: {
        caption: 'home',
        icon: 'assets/images/icons/home.svg'
    };
    discounts = [
        {
            image: 'assets/images/packages/banner1.jpg'
        }
    ];

    // loading state
    bestLoading = true;
    featureLoading = true;
    newLoading = true;

    private subscriptions = new Subscription();

    onRefresh = false;

    columns = [
        {
            header: this.storeService.getKeywords('Top_Rated_Products'),
            products: this.TopRated
        },
        {
            header: this.storeService.getKeywords('Special_Offers'),
            products: this.Featured
        },
        {
            header: this.storeService.getKeywords('Bestsellers'),
            products: this.Bestsellers
        }
    ];

    featuredProducts = {
        loading: true,
        products: this.Featured,
        groups: [],

        timeout: null, // only for demo

        groupChange: group => {
            // only for demo
            this.featuredProducts.loading = false;

            clearTimeout(this.featuredProducts.timeout);

            this.featuredProducts.timeout = setTimeout(() => {
                const itemsArray = this.featuredProducts.products;
                const newItemsArray = [];
                while (itemsArray.length > 0) {
                    const randomIndex = Math.floor(Math.random() * itemsArray.length);
                    const randomItem = itemsArray.splice(randomIndex, 1)[0];
                    newItemsArray.push(randomItem);
                }
                this.featuredProducts.products = newItemsArray;
                this.featuredProducts.loading = false;
            }, 1000);
        }
    };

    newArrivalsProducts = {
        loading: true,
        products: this.NewArrivals,
        groups: [],

        timeout: null, // only for demo

        groupChange: group => {
            // only for demo
            this.newArrivalsProducts.loading = false;

            clearTimeout(this.newArrivalsProducts.timeout);

            this.newArrivalsProducts.timeout = setTimeout(() => {
                const itemsArray = this.NewArrivals;
                console.log(products);
                let newItemsArray = [];
                console.log(group);
                if (group.name !== this.newArrivalsProducts.groups[0].name) {
                    newItemsArray = this.NewArrivals.filter(x => x.category.name === group.name);
                } else {
                    newItemsArray = itemsArray;
                }
                console.log(products);
                this.newArrivalsProducts.products = newItemsArray;
                this.newArrivalsProducts.loading = false;
            }, 0);
        }
    };



    constructor(
        public storeService: StoreService,
        private apiServices: ApiService,
        private postService: PostService,
    ) {
    }

    ngOnInit(): void {

        // load categories from localstroage
        try {
            this.categories = JSON.parse(localStorage.getItem('categories'));
        } catch { }

        this.subscriptions.add(
            this.apiServices.getRoute('product/Summary').subscribe(x => {
                const items = x.data.result as [];
                this.products = items;

                console.log(items.length);
                console.log(this.products);

                // featured - binding
                this.Featured = items.filter((d: any) => d.tags.includes(this.tags[0].toLowerCase()));
                this.loadFeatured(this.Featured);
                this.featuredProducts.products = this.Featured;
                // featured

                // Bestsellers - binding
                this.Bestsellers = items.filter((d: any) => d.tags?.includes(this.tags[1].toLowerCase()));
                this.bestLoading = false;
                // Bestsellers

                // NewArrival - binding
                this.NewArrivals = items.filter((d: any) => d.tags.includes(this.tags[2].toLowerCase()));
                this.loadNewArrivals(this.NewArrivals);
                this.newArrivalsProducts.products = this.NewArrivals;
                // NewArrival

                this.columns[0].products = items?.splice(0, 5);

            }));

    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    // tslint:disable-next-line:no-shadowed-variable
    loadFeatured(products: Product[]): void {
        // get all products categories
        let categorylist: { name: any, current: boolean }[] = [];
        let i = 0;
        products.forEach(function (v) {
            const vv = categorylist.find(x => x.name === v.category.name);
            //console.log(vv);
            if (!vv) {

                if(i==0){
                    categorylist.push({ name: ('*'), current: true  });
                }else{
                categorylist.push({ name: v.category.name, current: false });
                }
                
                console.log(categorylist[i]);
            }
            i++;
        });

        this.featuredProducts = {
            loading: false,
            products: products.slice(),
            groups: categorylist
            ,

            timeout: null, // only for demo

            groupChange: group => {
                // only for demo
                this.featuredProducts.loading = true;

                clearTimeout(this.featuredProducts.timeout);

                this.featuredProducts.timeout = setTimeout(() => {
                    const itemsArray = this.Featured;
                    console.log(products);
                    let newItemsArray = [];
                    console.log(group);
                    if (group.name !== this.featuredProducts.groups[0].name) {
                        newItemsArray = this.Featured.filter(x => x.category.name === group.name);
                    } else {
                        newItemsArray = itemsArray;
                    }
                    console.log(products);
                    this.featuredProducts.products = newItemsArray;
                    this.featuredProducts.loading = false;
                }, 1);
            }
        };
    }
    // tslint:disable-next-line:no-shadowed-variable
    loadNewArrivals(products: Product[]): void {
        // get all products categories
        let categorylist: { name: any, current: boolean }[] = [];
        let i = 0;
        products.forEach(function (v) {
            const vv = categorylist.find(x => x.name === v.category.name);
            //console.log(vv);
            if (!vv) {
                categorylist.push({ name: v.category.name, current: i === 0 ? true : false });
                console.log(categorylist[i]);
            }
            i++;
        });
        this.newArrivalsProducts = {
            loading: false,
            products,
            groups: categorylist,
            timeout: 0, // only for demo
            groupChange: group => {
                // only for demo
                this.newArrivalsProducts.loading = false;
                clearTimeout(this.newArrivalsProducts.timeout);
                this.newArrivalsProducts.timeout = setTimeout(() => {
                    const itemsArray = this.NewArrivals;
                    console.log(products);
                    let newItemsArray = [];
                    console.log(group);
                    if (group.name !== this.newArrivalsProducts.groups[0].name) {
                        newItemsArray = this.NewArrivals.filter(x => x.category.name === group.name);
                    } else {
                        newItemsArray = itemsArray;
                    }
                    console.log(products);
                    this.newArrivalsProducts.products = newItemsArray;
                    this.newArrivalsProducts.loading = false;
                }, 1000);
            }
        };
    }

}
